import { Navigate } from "react-router-dom";
import { useContext, ReactElement } from "react";
import { AuthContext } from "../context/AuthContext";

type Props = { children: ReactElement };

export default function PublicRoute({ children }: Props): ReactElement {
  const { state } = useContext(AuthContext);
  if (state.isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}